import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import { Checkbox } from '../../../components/ui/Checkbox';

const ReportGenerator = ({ onGenerate }) => {
  const [reportConfig, setReportConfig] = useState({
    type: 'registrations',
    format: 'csv',
    dateFrom: '',
    dateTo: '',
    includeMetrics: true,
    includeCharts: false
  });

  const reportTypeOptions = [
    { value: 'registrations', label: 'Registration Report' },
    { value: 'booth_performance', label: 'Booth Performance' },
    { value: 'engagement', label: 'Engagement Metrics' },
    { value: 'institute_analytics', label: 'Institute Analytics' },
    { value: 'student_activity', label: 'Student Activity' },
    { value: 'comprehensive', label: 'Comprehensive Report' }
  ];

  const formatOptions = [
    { value: 'csv', label: 'CSV' },
    { value: 'pdf', label: 'PDF' },
    { value: 'excel', label: 'Excel' }
  ];

  const handleGenerate = () => {
    onGenerate(reportConfig);
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-accent/10 rounded-lg flex items-center justify-center">
          <Icon name="FileText" size={24} color="var(--color-accent)" />
        </div>
        <div>
          <h3 className="text-lg font-heading font-semibold text-foreground">
            Generate Report
          </h3>
          <p className="text-sm text-muted-foreground">Export analytics and data</p>
        </div>
      </div>
      <div className="space-y-4">
        <Select
          label="Report Type"
          options={reportTypeOptions}
          value={reportConfig?.type}
          onChange={(value) => setReportConfig(prev => ({ ...prev, type: value }))}
        />

        <Select
          label="Export Format"
          options={formatOptions}
          value={reportConfig?.format}
          onChange={(value) => setReportConfig(prev => ({ ...prev, format: value }))}
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            label="From Date"
            type="date"
            value={reportConfig?.dateFrom}
            onChange={(e) => setReportConfig(prev => ({ ...prev, dateFrom: e?.target?.value }))}
          />
          <Input
            label="To Date"
            type="date"
            value={reportConfig?.dateTo}
            onChange={(e) => setReportConfig(prev => ({ ...prev, dateTo: e?.target?.value }))}
          />
        </div>

        <div className="border-t border-border pt-4 space-y-3">
          <p className="text-sm font-medium text-foreground">Include in Report:</p>
          <Checkbox
            label="Detailed Metrics"
            checked={reportConfig?.includeMetrics}
            onChange={(e) => setReportConfig(prev => ({ ...prev, includeMetrics: e?.target?.checked }))}
          />
          <Checkbox
            label="Charts and Graphs"
            checked={reportConfig?.includeCharts}
            onChange={(e) => setReportConfig(prev => ({ ...prev, includeCharts: e?.target?.checked }))}
          />
        </div>

        <Button
          fullWidth
          iconName="Download"
          onClick={handleGenerate}
        >
          Generate Report
        </Button>
      </div>
    </div>
  );
};

export default ReportGenerator;